import axios from "axios";
import { PERSIST_STORE_NAME } from "constants/app.constant";
import deepParseJson from "utils/deepParseJson";
import store from "../store";
import { onSignOutSuccess } from "../store/auth/sessionSlice";
import Cookies from "js-cookie";

export const TOKEN_TYPE = "Bearer ";
export const REQUEST_HEADER_AUTH_KEY = "Authorization";

const unauthorizedCode = [401];

const BaseService = axios.create({
  timeout: 60000,
  // baseURL: appConfig.apiPrefix[appConfig.stage],
});

BaseService.interceptors.request.use(
  (config) => {
    const rawPersistData = Cookies.get(PERSIST_STORE_NAME);
    const persistData = deepParseJson(rawPersistData);
    let accessToken = persistData.auth.session.token;

    if (!accessToken) {
      const { auth } = store.getState();
      accessToken = auth.session.token;
    }

    if (accessToken) {
      config.headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${accessToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

BaseService.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    if (response && unauthorizedCode.includes(response.status)) {
      store.dispatch(onSignOutSuccess());
    }

    return Promise.reject(error);
  }
);

export default BaseService;
